import {useState} from "react";
import {SubmissionDto, SubmissionFilterDto, SubmissionStateType} from "../../client/submission/SubmissionApiClient";
import {DetailActionButton} from "../../common/button/CommonActionButtons";
import {UserDto} from "../../client/user/User";
import {getStartOfPreviousYear} from "../../common/DateTimeUtils";
import {SubmissionColumn} from "../submission/SubmissionGrid";
import SubmissionDetailDialog from "../submission/SubmissionDetailDialog";
import RecentSubmissionSearchPanel from "./RecentSubmissionSearchPanel";
import {DEFAULT_PAGING_AND_SORTING_SUBMISSION_FILTER} from "../submission/search/SubmissionSearchPanel";

export interface SubmissionPanelProps {
    user: UserDto;
}

export function RecentSubmissionsPanel(props: Readonly<SubmissionPanelProps>) {
    const {user} = props;
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const [detailSubmissionId, setDetailSubmissionId] = useState<number>();
    const [selectedSubmission, setSelectedSubmission] = useState<SubmissionDto>();

    function showDetailDialog(submissionId: number) {
        setDetailSubmissionId(submissionId);
        setDetailDialogOpen(true);
    }

    function onDetailDialogClose() {
        setDetailDialogOpen(false)
    }

    function onSubmissionSelected(submission?: SubmissionDto) {
        setSelectedSubmission(submission);
    }

    const recentSubmissionsDefaultFilter: SubmissionFilterDto = {
        submissionStateTypeCodes: [
            SubmissionStateType.PROCESSED
        ],
        submittedById: user.id,
        submittedAtFrom: getStartOfPreviousYear(new Date()),
        ...DEFAULT_PAGING_AND_SORTING_SUBMISSION_FILTER,
    };

    const recentSubmissionsGridDefColumns: SubmissionColumn[] = [
        '#documentMetadata.type',
        'submittedAt',
        'submittedBy',
    ];

    const actions: React.ReactNode = (
        <>
            <DetailActionButton onClick={() => showDetailDialog(selectedSubmission!.id)}
                                disabled={!selectedSubmission}/>
        </>
    );

    return (
        <>
            <RecentSubmissionSearchPanel actions={actions}
                                         specificDefaultFilter={recentSubmissionsDefaultFilter}
                                         submissionsGridDefColumns={recentSubmissionsGridDefColumns}
                                         onSelectedSubmission={onSubmissionSelected}
                                         onSubmissionDoubleClick={showDetailDialog} />

            <SubmissionDetailDialog open={detailDialogOpen} submissionId={detailSubmissionId}
                                    onClose={onDetailDialogClose} />
        </>
    );
}
